import { useEffect } from 'react';

import { useAppDispatch } from '@/hooks';
import { useChainId } from '@/hooks/web3/useChain';

import { SYN_TRADE_TYPE } from '@/constants/storage';
import { TRADE_TYPE } from '@/constants/trade';
import { useCurrentPairFromUrl } from '@/features/pair/hook';
import { setTradeFormType } from '../actions';
import { useTradeStoreTransformed } from '../hooks';
function useResetStoreOnPairChange(chainId: number | undefined) {
  const currentPair = useCurrentPairFromUrl(chainId);
  const { setTradeSize, setTradePercent, setTradeQuoteSize } = useTradeStoreTransformed();
  useEffect(() => {
    if (currentPair?.id) {
      setTradeSize('');
      setTradePercent(0);
      setTradeQuoteSize('');
    }
  }, [currentPair?.id, setTradeSize, setTradePercent, setTradeQuoteSize]);
}
export function useResetChainFormType(chainId: number | undefined) {
  const formType = localStorage.getItem(SYN_TRADE_TYPE + chainId) || TRADE_TYPE.MARKET;
  const dispatch = useAppDispatch();
  useEffect(() => {
    chainId &&
      [TRADE_TYPE.MARKET, TRADE_TYPE.LIMIT, TRADE_TYPE.SCALE_LIMIT].includes(formType as TRADE_TYPE) &&
      dispatch(setTradeFormType({ chainId, tradeType: formType as TRADE_TYPE }));
  }, [chainId, dispatch, formType]);
}
function TradeGlobalEffect(): null {
  const chainId = useChainId();
  useResetStoreOnPairChange(chainId);
  // useResetChainFormType(chainId);
  return null;
}

export default TradeGlobalEffect;
